
import { Component, Vue, Prop } from 'vue-property-decorator'
import RobotMsgTmpl from '@/components/robot-msg-tmpl.vue'
import AnswerItem from '@/components/answer-item.vue'
import TtsAudio from '@/components/tts-audio.vue'

@Component({
  components: {
    RobotMsgTmpl,
    AnswerItem,
    TtsAudio
  }
})
export default class WelcomeMsg extends Vue {
  @Prop({ type: String, default: '' })
  robotImg!: string

  @Prop({ type: Boolean, default: true })
  showTts!: boolean
}
